import { checkoutItemsAdapter } from '../..';

export const getSummaryFulfilledAction = (state, { payload }) => {
	const { checkout, saved_for_later, summary } = payload || {};
	const checkoutOrders = checkout?.orders || [];
	const savedForLaterOrders = saved_for_later?.orders || [];

	checkoutItemsAdapter.upsertMany(state, [...checkoutOrders, ...savedForLaterOrders]);
	state.items = checkoutOrders.map(({ id }) => id).sort();
	state.savedForLaterItems = savedForLaterOrders.map(({ id }) => id).sort();

	state.errorMessage = '';
	state.success = true;
	state.isLoading = false;

	state.orderSummary = {
		...state.orderSummary,
		sections: {
			mainSummary: summary || [],
			checkoutSummary: checkout.summary || {},
			savedForLaterSummary: saved_for_later.summary || {},
		},
	};
};
